import type { HeroConfig } from '@src/components/sco/LayoutBlocks/Hero/types'

export const aboutLandingHeroConfig: HeroConfig = {
  title: 'We helped launch over a million startups',
  description: 'This is what we do.',
  backgroundColor: 'colorPalette.bg',
  backgroundGradient: 'linear(to-t, blackAlpha.500 25%, transparent 75%)',
  //   customContent: <TourStats />,
}
